( function( $, document, window ) {
    'use strict';
    const activeClass = 'is-active';

    $( function() {
        $( '.js-site-footer-item' ).each( function() {
        	let $location = $( this );
        	let $trigger = $( this ).find( '.js-site-footer-item-trigger' );
        	let $body = $( this ).find( '.js-site-footer-item-body' );

        	$trigger.on( 'click', function( event ) {
        		event.preventDefault();

        		// Exit early if above 580px
        		if ( window.matchMedia( '(min-width: 36.25em)' ).matches ) {
        			return;
		        }

        		$body.slideToggle();

		        if ( ! $location.hasClass( activeClass) ) {
			        $location.addClass( activeClass );
		        } else {
			        $location.removeClass( activeClass );
		        }
	        } );
        } );
    } );
} )( jQuery, document, window );
